import React, { useEffect, useState } from 'react'
import axios from "axios"
import BreadcrumbSection from '../components/BreadcrumbSection'
import phone from '../images/contact/contact.png'
import mail from '../images/contact/mail.png'
import location from '../images/contact/location.png'
import { Col, Container, Row } from 'react-bootstrap'
import breadcrumbImg from "../images/breadcrumb/contact.jpg"


const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });

  useEffect(()=>{
    window.scrollTo(0,0)
    document.title = "CollegeVidhyarthi | Contact"
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`${window.apiURL}/contactstore`, {
        name: formData.name,
        email: formData.email,
        mobileno: formData.mobile,
        message: formData.message
      })
    }
    catch (error) {
      alert(error)
    }
  }

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value})
  }

  return (
    <div>
      <BreadcrumbSection img={breadcrumbImg} activePage="Contact" pageTitle="Contact us" />
      <section className="contact-section">
        <Container fluid>
              <div className="contact-left">
                <Row>
                <Col md={4} className='mb-md-0 mb-4'>
                  <a href="http://maps.google.com/?q=1200 Jaipur" className="contact-block">
                        <div className="img_sec circlee1">
                          <img src={location} alt="College World" />
                        </div>
                        <div className="fw-bold font-16">Address</div>
                        <hr />
                        <span> Head Office - Jaipur<br />
                    Branch Office - Kota</span>
                  </a>
                </Col>
                <Col md={4} className='mb-md-0 mb-4'>
                  <a href="tel: 9549920000" className="contact-block">
                      <div className="img_sec circlee2">
                      <img src={phone} alt="College World" />
                    </div>
                    <div className="fw-bold font-16">Contact No.</div>
                    <hr />
                      <span>9549920000</span>
                  </a>
                </Col>
                <Col md={4}>
                  <a href="mailto: infocollegevidhyarthi@gmail.com" className="contact-block">
                      <div className="img_sec circlee3">
                      <img src={mail} alt="College World" />
                    </div>
                    <div className="fw-bold font-16">Mail</div>
                    <hr />
                      <span>infocollegevidhyarthi@gmail.com</span>
                  </a>
                </Col>
                </Row>
              </div>
              <div className="contact-form">
                <h4>Get in Touch With Us</h4>
                <form onSubmit={handleSubmit}>
                  <input type="text" name="name" placeholder='Full Name' onChange={handleChange} value={formData.className} />
                  <input type="text" name="email" placeholder='Email' onChange={handleChange} value={formData.email} />
                  <input type="text" name="mobile" placeholder='Mobile No.' onChange={handleChange} value={formData.mobile} />
                  <textarea rows="3" name="message" placeholder='Message' onChange={handleChange} value={formData.message} />
                  <input type="submit" value="Submit" />
                </form>
              </div>
          <iframe title='Map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.810661309088!2d75.75811456436504!3d26.877756018066023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db4f87fdcdf6d%3A0x752a034a62d4427d!2sNew%20Aatish%20Market%2C%20Shanthi%20Nagar%2C%20Mansarovar%2C%20Jaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1641899149457!5m2!1sen!2sin" width="100%" height="450" loading="lazy"></iframe>
        </Container>
      </section>
    </div>
  )
}

export default Contact
